(function () {
  document.querySelectorAll('.lp-ingredients__card').forEach(function (card) {
    var toggle = card.querySelector('.lp-ingredients__toggle');
    var description = card.querySelector('.lp-ingredients__description');

    if (!toggle) return;

    // Hide the toggle button when there is no description to expand
    if (!description) {
      toggle.hidden = true;
      return;
    }

    toggle.addEventListener('click', function () {
      var isOpen = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute(
        'aria-label',
        isOpen
          ? toggle.getAttribute('aria-label').replace('Show', 'Hide')
          : toggle.getAttribute('aria-label').replace('Hide', 'Show')
      );
    });
  });
})();
